import React from 'react'
import styled from 'styled-components'
import { devices } from 'Tool-kit/styles/mediaQueries'
import useThemeContext from '../../hooks/useThemeContext'

const ButtonWrapper = styled.button`
  text-transform: uppercase;
  padding: ${({ padding }) => padding || '2rem 7rem'};
  border-radius: ${({ roundedCorners }) => (roundedCorners ? '6px' : '')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.6rem;
  background: ${({ theme, toggleBackground, isDark }) =>
    !isDark && toggleBackground ? '#000000' : theme.colors.bnbYellow};
  color: ${({ theme, toggleBackground, isDark }) =>
    !isDark && toggleBackground ? '#ffffff' : theme.colors.textSecondary};
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  white-space: nowrap;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
  @media ${devices.phone} {
    padding: ${({ padding }) => padding || '2rem 3rem'};
  }
`

const Button = ({
  children,
  height,
  width,
  toggleBackground,
  roundedCorners,
  onClick,
  padding,
  disabled,
  maxWidth,
  ...props
}) => {
  const { isDark } = useThemeContext()
  return (
    <ButtonWrapper
      onClick={onClick}
      height={height}
      width={width}
      isDark={isDark}
      toggleBackground={toggleBackground}
      roundedCorners={roundedCorners}
      padding={padding}
      disabled={disabled}
      maxWidth={maxWidth}
      {...props}
    >
      {children}
    </ButtonWrapper>
  )
}

export default Button

const IconWrapper = styled.div`
  margin-right: 1.6rem;
`
export const IconButton = ({
  children,
  height,
  width,
  toggleBackground,
  roundedCorners,
  onClick,
  padding,
  Icon
}) => {
  const { isDark } = useThemeContext()
  return (
    <ButtonWrapper
      onClick={onClick}
      height={height}
      width={width}
      isDark={isDark}
      toggleBackground={toggleBackground}
      roundedCorners={roundedCorners}
      padding={padding}
    >
      <IconWrapper>{Icon}</IconWrapper>
      {children}
    </ButtonWrapper>
  )
}
